@use "sass:color";

.mvFetchResults {
    list-style-type: none;
    padding: 0;
    border: 1px solid #14456b33;
    font-size: 0.9rem;
    border-radius: 5px;
    overflow: hidden;
    width: 100%;
    display: flex;
    margin-top: 0;
    margin-bottom: 0;
    flex-direction: column;
}

.mvFetchResultsContainer {
    padding: 0.25rem 0.5rem;
    border-radius: 5px;
    width: 100%;
    h3 {
        margin-bottom: 0.4rem;
        font-size: 0.9rem;
        font-weight: 600;
        margin-top: 0.5rem;
    }
}

.mvFetchResult {
    padding: 0.25rem 0.5rem;
    display: flex;
    align-items: center;
    width: 100%;
    border: 0;
    appearance: none;
    background-color: rgba(0, 0, 0, 0.025);
    font-weight: 600;
    color: #14456b;
    cursor: pointer;
    border-bottom: 1px solid #14456b33;

    &:last-child {
        border-bottom: 0;
    }
}

.mvAreaUseFetchResultButton {
    margin-left: auto;
    border-radius: 5px;
    background-color: #f28e3d;
    text-transform: uppercase;
    padding: 0.5rem 1rem;
    cursor: pointer;
    color: #ffffff;
    transition: background-color 0.2s ease-in-out;
    &:hover {
        background-color: color.adjust(#f28e3d, $lightness: -5%);
    }
}

.mvFetchMarker {
    width: 11px;
    margin-right: 0.25rem;
}
